// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1jwuI","footer":"ChangeClinic_footer__239MP"};